import React from 'react'

// import appUtilities from '../utilities/appUtilities'

import BOMGrid from '../components/BOMGrid'
import { Container, Paper } from '@mui/material'

import PageFooter from '../components/PageFooter.js'
// import { productIDs } from 'data/productConstants'
// import { useLoadCheckout } from '../hooks/useLoadCheckout.js'

// INFO - creating this component so that the sessionObj stays stable after ea. re-render
// TODO: 06/25/23  perhaps consider doing the same for the ggl.js which has a constant changing sessionObj
export default function GridController({
    sessionObj,
    invList,
    isCAD,
    setIsCADCurrency,
}) {
    //CHECKOUT

    return (
        <Container
            sx={{
                maxWidth: { xs: '100%', sm: '95%' },
                mt: { xs: 2, sm: 10 },
                pl: { xs: 0.5, sm: 1 },
                pr: { xs: 0.5, sm: 1 },
            }}
        >
            <Paper elevation={8}>
                <BOMGrid
                    sessionObj={sessionObj}
                    invList={invList}
                    isCAD={isCAD}
                    setIsCADCurrency={setIsCADCurrency}
                />
            </Paper>
            <PageFooter />
        </Container>
    )
}
